export interface NavItem {
  label: string;
  route: string;
}

export const NAV_ITEMS: NavItem[] = [
  { label: 'HOME', route: '/' },
  { label: 'YACHTS', route: '/yachts' },
  { label: 'ABOUT', route: '/about' },
  { label: 'CONTACT', route: '/contact' },
  // { label: 'PRIVACY POLICY', route: '/privacy-policy' },
  // { label: 'TERMS OF SERVICE', route: '/terms-of-service' },
];
